'use strict';
checkList.classy.controller({
    name: 'AssetsExceeded',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService',
        'AddedAllowanceModelFactory', '$q'],
    init: function () 
    {
        this.familyID = this.ApplicationService.getFamilyData().data[0].familyID;
        this.AddedAllowanceModelService = new this.AddedAllowanceModelFactory(this.familyID);
        this.$.setAnswer();

        this.$.showBoxes = [0,0,0];
        this.$.savNotConsidered = parseInt(this.ApplicationService.getFamilyData().asset.Asset_Savings) - 
                                parseInt(this.ApplicationService.getAwardData().policy[0].Pref_20_saving);
        this.$.chkNotConsidered = parseInt(this.ApplicationService.getFamilyData().asset.Asset_Checking) - 
                                parseInt(this.ApplicationService.getAwardData().policy[0].Pref_20_checking);
        this.$.stkNotConsidered = parseInt(this.ApplicationService.getFamilyData().asset.Asset_Securities) - 
                                parseInt(this.ApplicationService.getAwardData().policy[0].Pref_20_stock);
        if (this.$.savNotConsidered > 0)
            this.$.showBoxes[0] = 1;
        if (this.$.chkNotConsidered > 0)
            this.$.showBoxes[1] = 1;
        if (this.$.stkNotConsidered > 0)
            this.$.showBoxes[2] = 1;
    },

    setAnswer: function()
    {
        var caseAttr = 'case84ans';
        if (this.ApplicationService.getFamilyData().apWizard[caseAttr].length > 5)
            this.$.answer = JSON.parse(this.ApplicationService.getFamilyData().apWizard[caseAttr]);
        else
            this.$.answer = {
                'savings': {'choice': 0},
                'checking': {'choice': 0},
                'stock': {'choice': 0}
            };
    },

    assetCompleteIndividual: function(type, allowanceName, assetNumber) {
        var self = this;
        var amount;

        // get id of addedAllowance (if exists)
        var addedAllowance = this.AddedAllowanceModelService.getById(this.$.answer[type].allowanceID);

        if (this.$.answer[type].choice != 0)
        {

            if (this.$.answer[type].choice == 1)
                amount = parseInt(assetNumber);
            else if (this.$.answer[type].choice == 2)
                amount = parseInt(this.$.answer[type].amount);

            // if addedAllowance doesn't exist
            if (typeof this.$.answer[type].allowanceID === 'undefined' || !addedAllowance)
            {
                // create a new allowance
                var index = this.AddedAllowanceModelService.new();
                addedAllowance = this.AddedAllowanceModelService.data[index];
                addedAllowance.text = allowanceName;
                addedAllowance.amount = amount;

                // post allowance, alert info, and update data
                var promise = this.$q.defer();
                this.AddedAllowanceModelService.post(this.familyID, addedAllowance).then(function(data){
                    self.$.answer[type].allowanceID = data.data.id;
                    addedAllowance.recordID = data.data.id;
                    promise.resolve();
                });
                return promise.promise;
            }
            else // if allowance does exist, update amount, alert info 
            {
                addedAllowance.amount = amount;
                return this.AddedAllowanceModelService.put(this.familyID, addedAllowance);
            }
        }
        else
        {
            // remove previous added allowance and put alert info
            if (this.$.answer[type].allowanceID)
                return this.AddedAllowanceModelService.purge(null, {recordID: this.$.answer[type].allowanceID});
            else 
                return this.$q.when(); //return empty promise
        }
    },

    assetsComplete: function () 
    {
        var queue = [];
        var self = this;
        queue.push(this.assetCompleteIndividual('savings', 'Savings', this.ApplicationService.getFamilyData().asset.Asset_Savings));
        queue.push(this.assetCompleteIndividual('checking', 'Checking', this.ApplicationService.getFamilyData().asset.Asset_Checking));
        queue.push(this.assetCompleteIndividual('stock', 'Stock', this.ApplicationService.getFamilyData().asset.Asset_Securities));
        this.$q.all(queue).then(function() {
            self.ApplicationService.getFamilyData().apWizard['case84ans'] = JSON.stringify(self.$.answer);
            self.AddedAllowanceModelService.updateData();
            self.$.alertPut(self.$q.when(), 'case84', 0, self.$.answer);
        });

    }
});
